import api from "../../../service/api";
import ActionTypes from "../../actionTypes";
import API_BOOK from "../../../service/endpoints";
import { customToast } from "../../../utils/toasts";

const { GET_ALL_DATA_SUCCESS, GET_ALL_DATA_FAIL } = ActionTypes.REPORTS.HISTORIC_DETAILS;
const { GET_ALL_HISTORIC_DETAILS, EXPORT_HISTORIC_DETAILS } = API_BOOK.REPORTS.HISTORIC_DETAILS;

/* Action dispatchers */

const getAllHistoricDetailsSuccessAD = (payload) => ({
  type: GET_ALL_DATA_SUCCESS,
  payload,
});

const getAllHistoricDetailsFailAD = () => ({
  type: GET_ALL_DATA_FAIL,
});

/* Actions */

/**
 *  @desc         Get all historic details data (OEM only, excludes TFT100)
 *  @api          /reports/historic-details
 *  @method       POST
 **/
export const GetHistoricDetails = ({ registrationNumbers, fromDate, toDate, pageSize, pageIndex }) => async (dispatch) => {
  try {
    const resp = await api({
      method: GET_ALL_HISTORIC_DETAILS.method,
      url: GET_ALL_HISTORIC_DETAILS.url,
      data: {
        registrationNumbers: registrationNumbers?.map((val) => val.label),
        fromDate,
        toDate,
        pageSize,
        pageIndex,
      }
    });

    if (resp.status === 200 && resp?.data?.data) {
      const response = resp?.data?.data;
      dispatch(getAllHistoricDetailsSuccessAD(response));
    } else {
      dispatch(getAllHistoricDetailsFailAD());
    }
  } catch (error) {
    dispatch(getAllHistoricDetailsFailAD());
    console.log("error:", error);
  }
};

/**
 *  @desc         Export historic details data (direct download)
 *  @api          /reports/historic-details/export
 *  @method       POST
 **/
export const ExportHistoricDetails = ({ registrationNumbers, fromDate, toDate }) => async (dispatch) => {
  try {
    const resp = await api({
      method: EXPORT_HISTORIC_DETAILS.method,
      url: EXPORT_HISTORIC_DETAILS.url,
      data: {
        registrationNumbers: registrationNumbers?.map((val) => val.label),
        fromDate,
        toDate,
      },
      responseType: 'arraybuffer'
    });

    if (resp.status === 200 && resp?.data) {
      const blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'historic_details_report.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      customToast({ message: 'Export Successful', secondaryMessage: 'File downloaded.', duration: 4000 });
    } else {
      const errorMsg = 'Export request failed. Please try again.';
      customToast({ message: 'Export Failed', secondaryMessage: errorMsg, duration: 6000, svgImageName: 'decline' });
    }
  } catch (error) {
    console.log("error:", error);
    customToast({ message: 'Export Failed', secondaryMessage: 'Something went wrong. Please try again.', duration: 6000, svgImageName: 'decline' });
  }
};
